module.exports = __webpack_public_path__ + "img/arrowUp24.aa2768dc.svg";